import { Grid } from "@material-ui/core"
import { CircularLoading } from "../../../../components"
import { useDefaultCadastroStyles } from "../../cadastros/components/default-cadastro-styles"
import { useStyles } from "./pedidos-sem-entregador-styles"
import { useCallback, useEffect, useRef, useState } from "react"
import { useSessaoAtual, useToastSaurus } from "../../../../../services/app"
import { PedidosSemEntregadorData } from "./pedidos-sem-entregador-data"
import { PedidoModel } from "../../../../../model/api/pedidos/pedido-model"
import { useGetPedido } from "../../../../../data/api/gestao/pedido/get-pedido"
import { EnumTipoPedido } from "../../../../../model/enums/enum-tipo-pedido"
import classNames from "classnames"
import { useParams } from "react-router-dom"
import { EnumStatusPedidoLocal } from "../../../../../model/enums/enum-status-pedido-local"

export const PedidosSemEntregadorList = () => {

    //AUX
    const classes = useStyles();
    const { showToast } = useToastSaurus();
    const listClasses = useDefaultCadastroStyles();
    const { getEmpresaSelecionada, usuario } = useSessaoAtual();
    const { pedidoId } = useParams<{ pedidoId?: string }>()
    const jaFoiInformado = useRef<boolean>(false);


    //STATES
    const [pedidos, setPedidos] = useState<PedidoModel[]>([]);

    //CHAMADAS DA API
    const { getPedido, carregando: carregandoPedidos } = useGetPedido()

    // CARREGANDO
    const carregando = carregandoPedidos;


    // GET PRODUTO PROCESSO SETOR 
    const search = useCallback(
        async () => {
            try {
                let query = `?tipoPedido=${EnumTipoPedido.ENTREGA}&semEntregador=true&status=${EnumStatusPedidoLocal.ENVIADO}&status=${EnumStatusPedidoLocal.EM_PREPARO}`
                const res = await getPedido(getEmpresaSelecionada()?.Id!, query);


                if (res.erro) throw res.erro;
                if (!res.resultado) return;

                const resultado = res.resultado.data.list as PedidoModel[]

                if (pedidoId && !resultado.find((item) => item.id === pedidoId) && !jaFoiInformado.current) {
                    showToast('error', 'Pedido não encontrado ou já assumiram a entrega.');
                    jaFoiInformado.current = true;
                }
                if (pedidoId) {
                    resultado.sort((a, b) => {
                        if (a.id === pedidoId) return -1;
                        if (b.id === pedidoId) return 1;
                        return 0;
                    })
                }

                setPedidos(resultado);
            } catch (e: any) {
                showToast('error', e.message);
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [usuario?.usuarioId, getEmpresaSelecionada, showToast],
    );

    useEffect(() => {
        search();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Grid className={classes.container}>
                <div className={classes.defaultContainer}>
                    {carregando && <CircularLoading tipo="FULLSIZED" />}
                    <Grid className={classNames(listClasses.list, classes.list)}>
                        <Grid item xs={12} container className={classes.listContainer}>
                            <PedidosSemEntregadorData
                                carregando={carregando}
                                list={pedidos}
                                handleReloadPedidos={search}
                                pedidoIdParam={pedidoId}
                            />
                        </Grid>
                    </Grid>
                </div>
            </Grid>
        </>
    )
}